import { FC } from 'react';
import { SessionPresentationProps } from '../config';
import { Text } from 'react-native';
import { observer } from 'mobx-react';
import { useStores } from '../../../hooks/useStores';

const _PresentDefault : FC<SessionPresentationProps> = () => {
  const { treeNav } = useStores();
  const stepType = treeNav.content.stepType;
  return (
    <Text>
      {`Session step presentation for ${stepType} not implemented.`}
    </Text>
  );
};
export const PresentDefault = observer(_PresentDefault);
